import React from 'react';
import PropTypes from 'prop-types';
import { DateTime } from 'luxon';

import fileIcon from '../../../constants/fileIcon';
import Text from '../../Text/Text';
import Badge from '../../Badge/Badge';
import ButtonTypes from '../../../constants/buttonTypes';

const UploadMenuItem = ({ item }) => {
  const {
    type,
    url,
    created_at: createdAt,
    format,
    user: { login, last_name: lastName, name },
  } = item;
  const Icon = fileIcon[format] || fileIcon.xlsx;

  const date = DateTime.fromISO(createdAt.replace(' ', 'T'))
    .setLocale('en').toRelative();

  return (
    <div className="flex flex-row items-center justify-around px-[13px]">
      <div className="flex-1">
        <Icon heigth={30} width={30} />
      </div>
      <div className="flex justify-start flex-[5] ml-[20px] mr-[20px]">
        <div className="flex flex-col">
          <div>
            <a href={url} target="_blank" className="globalLink" rel="noreferrer">{type}</a>
          </div>
          <div><Text text={`by: ${login || `${name} ${lastName}`}`} muted /></div>
        </div>
      </div>
      <div className="flex-1 ml-[20px]">
        <Badge text={date} type={ButtonTypes.LIGHT} />
      </div>
    </div>
  );
};

UploadMenuItem.propTypes = {
  item: PropTypes.shape({
    type: PropTypes.string,
    url: PropTypes.string,
    format: PropTypes.string,
    created_at: PropTypes.string,
    user: PropTypes.shape({
      login: PropTypes.string,
      last_name: PropTypes.string,
      name: PropTypes.string,
    })
  }).isRequired
};

UploadMenuItem.defaultProps = {};

export default UploadMenuItem;
